<template>
  <div>
    <b-overlay :show="loading">
      <b-container fluid>
        <span 
          v-if="zaprosInfo"
          @click="visible = 'zapros'"
          :class="visible === 'zapros' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Запрос на котировку</span>
        <span 
          v-if="obshayaInfo"
          @click="visible = 'obshaya'"
          :class="visible === 'obshaya' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Общая информация</span>
        <span 
          v-if="etapyDvigeniya"
          @click="visible = 'etapy'"
          :class="visible === 'etapy' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Этапы движения</span>
        <span 
          v-if="timelinePostavki"
          @click="visible = 'graph'"
          :class="visible === 'graph' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Таймлайн поставки</span>
      </b-container>

      <div v-show="visible === 'zapros'">
        <b-card>
          <b-container fluid>
            <template v-if="detailedItem.quotation && detailedItem.quotation.data">
                <OrderServiceDeliveryQuotationInfo 
                    :quotation="detailedItem.quotation"
                    :showAnswers="true"
                />
            </template>
            <template v-else>
                <div style="font-style: italic; padding: 25px 15px">Запрос на котировку не составлялся.</div>
            </template>
          </b-container>
        </b-card>
      </div>

      <div v-show="visible === 'obshaya'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="6" md="2">
                    <label for="nomer_of_dogovor">Номер договора:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-input v-model="editedData['0'].value" size="sm" placeholder="" :disabled="true"></b-form-input>
                    <template v-if="editMode && filteredDocs.length > 0">
                      <div class="upDocSelectLinksHead mt-1 font-weight-bold">Выберите договор:</div>
                      <div 
                          v-for="doc in filteredDocs" 
                          @click="changeSelectedDoc(doc)"
                          :key="doc.id"
                          class="docSelectLinks"
                      >
                          {{ doc.name }} ({{ doc.date_of_document | formattedDate }})
                      </div>
                    </template>                                        
                    <template v-if="editMode && filteredDocs.length == 0">
                      <div class="upDocSelectLinksHead mt-1 font-weight-bold">Добавьте в компанию <br />хотя бы один договор ТЭО!</div>
                    </template>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label for="data_of_dogovor">Дата договора:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-input v-model="editedData['1'].value" type="date" size="sm" placeholder="" :disabled="true"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Наименование груза, код ТНВЭД:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['name_of_cargo']" name="name_of_cargo" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="import_export">Импорт / Экспорт:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select 
                      v-model="editedData['import_export']" 
                      name="import_export" 
                      size="sm" 
                      placeholder="" 
                      :options="[
                        { value: 'Импорт', text: 'Импорт' },
                        { value: 'Экспорт', text: 'Экспорт' }
                      ]"
                      :disabled="!localEditMode"
                    ></b-form-select>
                  </b-col>
                </b-row>                
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="usloviya_postavki_id">Условие поставки:</label>
                  </b-col>
                  <b-col sm="4">
                    <tsoft-select-of-properties
                      :reference_id="68"
                      :needNullElement="true"
                      :disabled="!localEditMode"
                      :selected="editedData['usloviya_postavki_id']"
                      index="usloviya_postavki_id"
                      @set="setReferenceValue"
                    ></tsoft-select-of-properties>  
                  </b-col>
                  <b-col sm="2">
                    <label for="naselenniy_punkt">Населенный пункт:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['naselenniy_punkt']" name="naselenniy_punkt" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid class="mt-3">
            <b-row class="my-2 mb-3">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="cargo_recipient_name">Грузополучатель:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['cargo_recipient_name']" name="cargo_recipient_name" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_g_p">Адрес ГП:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_g_p']" name="address_g_p" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_of_unloading">Адрес разгрузки:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_of_unloading']" name="address_of_unloading" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="contact_name_on_unloading">Контактное лицо на разгрузке, телефон:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['contact_name_on_unloading']" name="contact_name_on_unloading" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="notify_contacts">Notify:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['notify_contacts']" name="notify_contacts" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="agent_contacts">Агент:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['agent_contacts']" name="agent_contacts" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="2">
                <label for="perevozchik_id">Перевозчик:</label>
              </b-col>
              <b-col sm="10">
                <tsoft-select-company
                  :needNullElement="true"
                  :selected="editedData['perevozchik_id']"
                  :disabled="!localEditMode"
                  :additionalGetParams="`&is_transport_company=1&checked_id=444`"
                  @set="setCompanyPerevozchikOfOrder"
                ></tsoft-select-company>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="0" md="2"></b-col>
              <b-col sm="12" md="5">                
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="perevozchik_name">Перевозчик. Наименование:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input 
                        v-model="editedData['perevozchik_name']" 
                        name="perevozchik_name" 
                        size="sm" 
                        placeholder="" 
                        :disabled="true"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="5">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="perevozchik_inn">Перевозчик. ИНН:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input 
                        v-model="editedData['perevozchik_inn']" 
                        name="perevozchik_inn" 
                        size="sm" 
                        placeholder="" 
                        :disabled="true"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="0" md="2"></b-col>
              <b-col sm="12" md="10">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="perevozchik_uridicheskiy_address">Перевозчик. Юр. адрес:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input 
                        v-model="editedData['perevozchik_uridicheskiy_address']" 
                        name="perevozchik_uridicheskiy_address" 
                        size="sm" 
                        placeholder="" 
                        :disabled="true"
                    ></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="4">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="port_of_shipment">Порт погрузки:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['port_of_shipment']" name="port_of_shipment" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="port_of_unloading">Порт разгрузки:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['port_of_unloading']" name="port_of_unloading" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="station_of_incoming_id">Станция прибытия:</label>
                  </b-col>
                  <b-col sm="8">
                    <tsoft-select-of-properties
                      :reference_id="70"
                      :needNullElement="true"
                      :disabled="!localEditMode"
                      :selected="editedData['station_of_incoming_id']"
                      index="station_of_incoming_id"
                      @set="setReferenceValue"
                    ></tsoft-select-of-properties>  
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid>
            <b-row>
              <b-col sm="12" class="d-flex" style="flex-direction: row; justify-content: space-between; align-content: center; align-items: center;">
                <h5 class="my-0 py-0">Контейнеры</h5>
                <button  
                  v-if="localEditMode"
                  class="btn btn-sm btn-outline-secondary" 
                  @click="addContainer()"
                >Добавить контейнер <i class="fas fa-plus ml-1"></i></button>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid>
            <b-row 
              class="my-2 one-container"
              style="align-items: baseline;"
              v-for="(one_container, container_index) in editedData['containers']"
              :key="`container_${container_index}`"
            >
              <b-col sm="2">
                <label for="containers">Контейнер {{ container_index + 1 }}:</label>
                <div v-if="container_index != 0">
                  <button 
                    :disabled="!localEditMode" 
                    class="btn btn-sm btn-outline-secondary" 
                    @click="deleteContainer(container_index)">Убрать<i class="far fa-trash-alt ml-2"></i></button>
                </div>
              </b-col>
              <b-col sm="10">
                <b-row class="my-2">
                  <b-col sm="12" md="6">
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="nomer_of_container">№ контейнера:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_container['nomer_of_container']" name="nomer_of_container" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="number_of_places">Кол-во мест:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_container['number_of_places']" type="number" name="number_of_places" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="weight">Вес, кг.:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_container['weight']" type="number" name="weight" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="volume">Объем, м<sup>3</sup>:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_container['volume']" type="number" name="volume" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="12" md="6">
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="type_of_container_id">Тип контейнера:</label>
                      </b-col>
                      <b-col sm="8">
                        <tsoft-select-of-properties
                          :reference_id="56"
                          :needNullElement="true"
                          :disabled="!localEditMode"
                          :selected="one_container['type_of_container_id']"
                          :index="`containers.${container_index}.type_of_container_id`"
                          @set="setReferenceValue"
                          :key="`container_type_${container_index}`"
                        ></tsoft-select-of-properties>  
                      </b-col>
                    </b-row>

                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="name_of_ship">Название судна:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_container['name_of_ship']" name="name_of_ship" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="shipping_line">Судоходная линия:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input v-model="one_container['shipping_line']" name="shipping_line" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row class="my-2">
                      <b-col sm="4">
                        <label for="country_of_ship_registration_id">Страна регистрации судна:</label>
                      </b-col>
                      <b-col sm="8">
                        <tsoft-select-of-properties
                          :reference_id="71"
                          :needNullElement="true"
                          :disabled="!localEditMode"
                          :selected="one_container['country_of_ship_registration_id']"
                          :index="`containers.${container_index}.country_of_ship_registration_id`"
                          @set="setReferenceValue"
                          :key="`container_country_${container_index}`"
                          ></tsoft-select-of-properties>  
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="12" class="d-flex" style="flex-direction: row; justify-content: space-between; align-content: center; align-items: center;">
                    <h6 class="my-0 py-0">Коносаменты в контейнере {{ container_index + 1 }}</h6>
                    <button  
                      v-if="localEditMode"
                      class="btn btn-sm btn-outline-secondary" 
                      @click="addKonosament(container_index)"
                    >Добавить коносамент <i class="fas fa-plus ml-1"></i></button>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="12">
                    <b-row
                      v-for="(one_konosament, konosament_index) in one_container.konosaments"
                      class="my-2 position-relative one-konosament"
                      :key="`container_${container_index}_konosament_${konosament_index}`"
                    >
                      <b-col sm="12">
                        <b-row class="my-2">
                          <b-col sm="12" md="6">
                            <b-row class="my-2">
                              <b-col sm="4">
                                <label for="number_of_konosament">№ коносамента {{ konosament_index + 1 }}:</label>
                              </b-col>
                              <b-col sm="8">
                                <b-form-input v-model="one_konosament['number_of_konosament']" name="number_of_konosament" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                              </b-col>
                            </b-row>
                            <b-row class="my-2">
                              <b-col sm="4">
                                <label for="sales_name">Продавец:</label>
                              </b-col>
                              <b-col sm="8">
                                <b-form-input v-model="one_konosament['sales_name']" name="sales_name" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                              </b-col>
                            </b-row>
                          </b-col>
                          <b-col sm="12" md="6">
                            <b-row class="my-2">
                              <b-col sm="4">
                                <label for="date_of_konosament_exit">Дата выпуска коносамента:</label>
                              </b-col>
                              <b-col sm="8">
                                <b-form-input v-model="one_konosament['date_of_konosament_exit']" type="date" name="date_of_konosament_exit" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                              </b-col>
                            </b-row>
                            <b-row class="my-2">
                              <b-col sm="4">
                                <label for="cargo_sender_name">Грузоотправитель:</label>
                              </b-col>
                              <b-col sm="8">
                                <b-form-input v-model="one_konosament['cargo_sender_name']" name="cargo_sender_name" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        <b-row class="my-2">
                          <b-col sm="12" md="12">
                            <b-row class="my-2">
                              <b-col sm="2">
                                <label for="address_g_o">Адрес ГО:</label>
                              </b-col>
                              <b-col sm="10">
                                <b-form-input v-model="one_konosament['address_g_o']" name="address_g_o" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                              </b-col>
                            </b-row>
                            <b-row class="my-2">
                              <b-col sm="2">
                                <label for="contact_name_on_shipment">Контактное лицо на погрузке, телефон:</label>
                              </b-col>
                              <b-col sm="10">
                                <b-form-input v-model="one_konosament['contact_name_on_shipment']" name="contact_name_on_shipment" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      </b-col>
                      <div 
                        v-if="konosament_index != 0"
                        class="delete-one-konosament" 
                      >
                        <button 
                          :disabled="!localEditMode" 
                          class="btn btn-sm btn-outline-secondary" 
                          @click="deleteKonosament(container_index, konosament_index)"
                        >Убрать<i class="far fa-trash-alt ml-2"></i></button>
                      </div>
                    </b-row>
                  </b-col>
                </b-row>   
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>

      <div v-show="visible === 'etapy'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Маршрут</label>
                  </b-col>
                  <b-col sm="10">
                    <b-list-group horizontal="md">
                      <b-list-group-item variant="secondary">
                        <span class="small-description">условия поставки</span>
                        {{ nameByPropId(editedData.usloviya_postavki_id) || '<Укажите условия поставки>' }} / {{ takeTypeOfContainer(editedData.containers) || '<Укажите тип контейнера>' }}
                      </b-list-group-item>
                      <b-list-group-item variant="secondary">
                        <span class="small-description">адрес погрузки</span>
                        {{ editedData.naselenniy_punkt || '<Укажите населенный пункт>' }}
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['vihod_sudna_iz_porta_plan'], editedData['vihod_sudna_iz_porta_fact'])">
                        <span class="small-description">порт отгрузки</span>
                        {{ editedData.port_of_shipment || '<Укажите порт отгрузки>' }}<br>
                        <small>{{ editedData['vihod_sudna_iz_porta_fact'] || editedData['vihod_sudna_iz_porta_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['pribitie_sudna_v_port_plan'], editedData['pribitie_sudna_v_port_fact'])">
                        <span class="small-description">порт прибытия</span>
                        {{ editedData.port_of_unloading || '<Укажите порт прибытия>' }}<br>
                        <small>{{ editedData['pribitie_sudna_v_port_fact'] || editedData['pribitie_sudna_v_port_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <template v-if="editedData['station_of_incoming_id'] != 888">
                        <b-list-group-item :variant="variantByTwoDays(editedData['raskreditaciya_plan'], editedData['raskreditaciya_fact'])">
                          <span class="small-description">станция прибытия</span>
                          {{ nameByPropId(editedData.station_of_incoming_id) || '<Укажите станцию прибытия>' }}<br>
                          <small>{{ editedData['raskreditaciya_fact'] || editedData['raskreditaciya_plan'] || '<Даты нет>' | formattedDate }}</small>
                        </b-list-group-item>
                      </template>
                      <b-list-group-item :variant="variantByTwoDays(editedData['dostavka_plan'], editedData['dostavka_fact'])">
                        <span class="small-description">адрес разгрузки</span>
                        {{ editedData.address_of_unloading || '<Укажите адрес разгрузки>' }}<br>
                        <small>{{ editedData['dostavka_fact'] || editedData['dostavka_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                    </b-list-group>                    
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr>
            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                  </b-col>
                  <b-col sm="4" class="text-center">
                    План
                  </b-col>
                  <b-col sm="4" class="text-center">
                    Факт
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="gotovnost_gruza_plan">Готовность груза:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['gotovnost_gruza_plan']" 
                        name="gotovnost_gruza_plan" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['gotovnost_gruza_fact']" 
                        name="gotovnost_gruza_fact" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col class="bg-gray-right">
                        <div class="details-group">
                            <div class="value-of-field">
                              <div class="table-document-correction">
                                <div class="text-uppercase">
                                    <div>
                                        <i v-if="editedData['naselenniy_punkt']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['naselenniy_punkt']" class="bx bx-x text-danger mr-2"></i>
                                        Населенный пункт
                                    </div>
                                    <div>
                                        <i v-if="editedData['cargo_recipient_name']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['cargo_recipient_name']" class="bx bx-x text-danger mr-2"></i>
                                        Грузополучатель
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_g_p']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_g_p']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес ГП
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_of_unloading']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_of_unloading']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес разгрузки
                                    </div>
                                    <div>
                                        <i v-if="editedData['contact_name_on_unloading']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['contact_name_on_unloading']" class="bx bx-x text-danger mr-2"></i>
                                        Контактное лицо на разгрузке
                                    </div>
                                    <div>
                                        <i v-if="editedData['perevozchik_name'] &&
                                                 editedData['perevozchik_inn'] &&
                                                 editedData['perevozchik_uridicheskiy_address']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['perevozchik_name'] ||
                                                 !editedData['perevozchik_inn'] ||
                                                 !editedData['perevozchik_uridicheskiy_address']" class="bx bx-x text-danger mr-2"></i>
                                        Данные по перевозчику
                                    </div>
                                    <div>
                                        <i v-if="hasDocumentWithId339" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId339" class="bx bx-x text-danger mr-2"></i>
                                        В документах «Заявка на перевозку»
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="descr-of-field">Для проставления готовности груза, заполните поля, добавьте документы.</div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="zatarka_containera_plan">Затарка контейнера:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['zatarka_containera_plan']" 
                        name="zatarka_containera_plan" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['zatarka_containera_fact']" 
                        name="zatarka_containera_fact" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col class="bg-gray-right">
                        <div class="details-group">
                            <div class="value-of-field">
                              <div class="table-document-correction">
                                <div class="text-uppercase">
                                    <div>
                                        <i v-if="hasDocumentWithId339" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId339" class="bx bx-x text-danger mr-2"></i>
                                        Заявка на перевозку
                                    </div>
                                    <div>
                                        <i v-if="hasDocumentWithId353" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId353" class="bx bx-x text-danger mr-2"></i>
                                        Страховой полис
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="descr-of-field">Для проставления затарки контейнера, добавьте документы.</div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="vihod_sudna_iz_porta_plan">Выход судна из порта:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vihod_sudna_iz_porta_plan']" name="vihod_sudna_iz_porta_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vihod_sudna_iz_porta_fact']" name="vihod_sudna_iz_porta_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="pribitie_sudna_v_port_plan">Прибытие судна в порт:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_sudna_v_port_plan']" name="pribitie_sudna_v_port_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_sudna_v_port_fact']" name="pribitie_sudna_v_port_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center">
                <label>Транзитное время:</label>
                <div>{{ editedData['port_of_shipment'] || '<Укажите порт погрузки>' }} - {{ editedData['port_of_unloading'] || '<Укажите порт разгрузки>' }}</div>
                <div class="bigNumber">{{ transitnoe_vremya }}</div>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="poluchenie_konosamenta_fact">Получение коносамента:</label>
                  </b-col>
                  <b-col sm="4"></b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['poluchenie_konosamenta_fact']" name="poluchenie_konosamenta_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="podacha_dt_fact">Подача ДТ:</label>
                  </b-col>
                  <b-col sm="4"></b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['podacha_dt_fact']" name="podacha_dt_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="vypusk_dt_fact">Выпуск ДТ:</label>
                  </b-col>
                  <b-col sm="4"></b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vypusk_dt_fact']" name="vypusk_dt_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center">
                <label>Время ТО:</label>
                <div class="bigNumber">{{ time_of_to }}</div>
              </b-col>
            </b-row>

            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2" v-if="editedData['station_of_incoming_id'] != 888">
                  <b-col sm="4">
                    <label for="vyhod_po_gd_plan">Выход по ЖД:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vyhod_po_gd_plan']" name="vyhod_po_gd_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vyhod_po_gd_fact']" name="vyhod_po_gd_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2" v-if="editedData['station_of_incoming_id'] != 888">
                  <b-col sm="4">
                    <label for="pribitie_na_stanciyu_plan">Прибытие на станцию:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_na_stanciyu_plan']" name="pribitie_na_stanciyu_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['pribitie_na_stanciyu_fact']" name="pribitie_na_stanciyu_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="raskreditaciya_plan">Раскредитация:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['raskreditaciya_plan']" name="raskreditaciya_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['raskreditaciya_fact']" name="raskreditaciya_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="dostavka_plan">Доставка:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['dostavka_plan']" name="dostavka_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['dostavka_fact']" name="dostavka_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center" v-if="editedData['station_of_incoming_id'] != 888">
                <label>Транзитное время:</label>
                <div>{{ editedData['port_of_unloading'] || '<Укажите порт разгрузки>' }} - {{ nameByPropId(editedData['station_of_incoming_id']) || '<Укажите станцию прибытия>' }}</div>
                <div class="bigNumber">{{ transitnoe_vremya_gd }}</div>
              </b-col>
              <b-col sm="12" md="4" class="text-center" v-if="editedData['station_of_incoming_id'] == 888">
                <label>Транзитное время:</label>
                <div>{{ editedData['port_of_unloading'] || '<Укажите порт разгрузки>' }} - {{ editedData['address_of_unloading'] || '<Укажите адрес разгрузки>' }}</div>
                <div class="bigNumber">{{ transitnoe_vremya_gd_bez_gd }}</div>
              </b-col>
            </b-row>

            <hr>
            <b-row class="my-2">
              <b-col sm="12" class="text-center">
                <div class="bigNumber transitItogBlock">Общее транзитное время: {{ obshee_transitnoe_vremya }}</div>
              </b-col>
            </b-row>

          </b-container>
          
        </b-card>
      </div>

      <ActiveHistory
        v-if="visible === 'graph'"
        :serviceIds="detailedItem.id"
      />
    </b-overlay>
  </div>
</template>

<script>
import OrderServiceDeliveryQuotationInfo from '@/components/orders/orderServiceQuotation/OrderServiceDeliveryQuotationInfo.vue';
import ActiveHistory from '@/components/orders/orderServiceTemplate/v2/ActiveHistory';
import {
  constantsAllReferenceProperties,
  dateHelpers,
  dataHelpers
} from '@/mixins';

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    saveMode: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      required: true,
    },
    filteredDocs: {
      type: Array,
      required: true,
    },
    zaprosInfo: {
      type: Boolean,
      default: true,
    },
    obshayaInfo: {
      type: Boolean,
      default: true,
    },
    etapyDvigeniya: {
      type: Boolean,
      default: true,
    },
    timelinePostavki: {
      type: Boolean,
      default: true,
    },
    defaultVisible: {
      type: String,
      default: 'obshaya',
    },
  },
  mixins: [
    constantsAllReferenceProperties,
    dateHelpers,
    dataHelpers
  ],
  components: {ActiveHistory, OrderServiceDeliveryQuotationInfo},
  data() {
    return {
      loading: false,
      localEditMode: false,
      visible: 'obshaya',
      editedData: {
        "0": { value: '' },
        "1": { value: '' },
        name_of_cargo: '',
        import_export: 'Импорт',
        usloviya_postavki_id: null,
        naselenniy_punkt: '',

        cargo_recipient_name: '',
        address_g_p: '',
        address_of_unloading: '',
        contact_name_on_unloading: '',
        notify_contacts: '',
        agent_contacts: '',

        perevozchik_id: null,
        perevozchik_name: '',
        perevozchik_inn: '',
        perevozchik_uridicheskiy_address: '',

        port_of_shipment: '',
        port_of_unloading: '',
        station_of_incoming_id: null,

        number_of_container: 1, // Меняется при добавлении / удалении контейнера

        containers: [
          {
            number_of_places: 0,
            weight: 0,
            volume: 0,
            type_of_container_id: null,
            shipping_line: '',
            nomer_of_container: '',
            name_of_ship: '',
            country_of_ship_registration_id: null,
            konosaments: [
              {
                number_of_konosament: '',
                date_of_konosament_exit: '',
                sales_name: '',
                cargo_sender_name: '',
                address_g_o: '',
                contact_name_on_shipment: '',
              }
            ],
          }
        ],

        gotovnost_gruza_plan: '',
        gotovnost_gruza_fact: '',
        zatarka_containera_plan: '',
        zatarka_containera_fact: '',
        vihod_sudna_iz_porta_plan: '',
        vihod_sudna_iz_porta_fact: '',
        pribitie_sudna_v_port_plan: '',
        pribitie_sudna_v_port_fact: '', 
        poluchenie_konosamenta_fact: '',
        podacha_dt_fact: '',
        vypusk_dt_fact: '',
        transitnoe_vremya: '',
        time_of_to: '',
        vyhod_po_gd_plan: '',
        vyhod_po_gd_fact: '',
        pribitie_na_stanciyu_plan: '',
        pribitie_na_stanciyu_fact: '',
        raskreditaciya_plan: '', 
        raskreditaciya_fact: '', 
        dostavka_plan: '',
        dostavka_fact: '',
        transitnoe_vremya_gd: '',
        obshee_transitnoe_vremya: ''
      },
    };
  },  
  computed: {
    transitnoe_vremya() {
      if (!this.editedData['pribitie_sudna_v_port_fact'] || !this.editedData['vihod_sudna_iz_porta_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['vihod_sudna_iz_porta_fact'], this.editedData['pribitie_sudna_v_port_fact']);
      return transitnoe_vremya;      
    },
    time_of_to() {
      if (!this.editedData['vypusk_dt_fact'] || !this.editedData['podacha_dt_fact']) {
        // return 'Заполните поля <Выпуск ДТ> и <Подача ДТ>';
        return "<Расчет недоступен>";
      } 

      const time_of_to = this.getDiffNumberOfDays(this.editedData['podacha_dt_fact'], this.editedData['vypusk_dt_fact']);
      return time_of_to;
    },
    transitnoe_vremya_gd() {
      if (!this.editedData['raskreditaciya_fact'] || !this.editedData['vyhod_po_gd_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['vyhod_po_gd_fact'], this.editedData['raskreditaciya_fact']);
      return transitnoe_vremya;      
    },
    transitnoe_vremya_gd_bez_gd() {
      if (!this.editedData['raskreditaciya_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['raskreditaciya_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya;      
    },
    obshee_transitnoe_vremya() {
      if (!this.editedData['zatarka_containera_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['zatarka_containera_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya;      
    },
    hasDocumentWithId339() {
        const hasDocumentWithId339 = this.detailedItem.documents && 
            this.detailedItem.documents.some(document => document.reference_document_type_id === 339);

        return hasDocumentWithId339;
    },
    hasDocumentWithId353() {
        const hasDocumentWithId353 = this.detailedItem.documents && 
            this.detailedItem.documents.some(document => document.reference_document_type_id === 353);

        return hasDocumentWithId353;
    },
    isCanFillGotovnostGruza() {
        return true;
    }
  },
  watch: {
    editMode: {
      handler(value) {
        this.localEditMode = value;
      },
      immediate: true
    },
    saveMode: {
      handler(value) {
        if (value == true) {
          this.$emit('updateData', this.editedData);
        }
      },
      immediate: true
    },
    detailedItem: {
      handler(data) {
        // this.editedData = Object.assign(this.editedData, JSON.parse(JSON.stringify(data.data)));
        this.editedData = this.deepMergeSafeFirst(JSON.parse(JSON.stringify(data.data)), JSON.parse(JSON.stringify(this.editedData)));
      },
      deep: true,
      immediate: true
    },
    transitnoe_vremya(value) {
      this.editedData['transitnoe_vremya'] = value;
    },
    time_of_to(value) {
      this.editedData['time_of_to'] = value;
    },
    obshee_transitnoe_vremya(value) {
      this.editedData['obshee_transitnoe_vremya'] = value;
    }
  },
  mounted() {
    this.visible = this.defaultVisible;
  },
  methods: {
    setReferenceValue(value, reference_id, index) {
      let indexArray = index.split('.');
      if (indexArray.length > 1) {
        if (indexArray[0] == 'containers') {
          if (indexArray[2] != 'konosamets') {
            this.editedData[indexArray[0]][indexArray[1]][indexArray[2]] = value;  
          }
        }
      } else {
        this.editedData[index] = value;
      }
    }, 
    setCompanyPerevozchikOfOrder(value, element) {
      this.editedData['perevozchik_id'] = value;
      this.editedData['perevozchik_name'] = element.name;
      this.editedData['perevozchik_inn'] = element.inn;
      this.editedData['perevozchik_uridicheskiy_address'] = element.address;
    },
    changeSelectedDoc(doc) {
      this.editedData[0].value = doc.name;
      this.editedData[1].value = doc.date_of_document;
    },  
    addContainer() {
      let prevContainer = this.editedData['containers'][this.editedData['containers'].length - 1];
      this.editedData['containers'].push(JSON.parse(JSON.stringify(prevContainer)));
      this.editedData['number_of_container']++;
    },
    deleteContainer(container_index) {
      this.editedData['containers'].splice(container_index, 1);
      this.editedData['number_of_container']--;
    },
    addKonosament(container_index) {
      let prevKonosament = this.editedData['containers'][container_index]['konosaments'][this.editedData['containers'][container_index]['konosaments'].length - 1];
      this.editedData['containers'][container_index]['konosaments'].push(JSON.parse(JSON.stringify(prevKonosament)));
    },
    deleteKonosament(container_index, konosament_index) {
      this.editedData['containers'][container_index]['konosaments'].splice(konosament_index, 1);
    },
  }
};
</script>
<style scoped>
.one-container {
  background: #f2f2f2;
  border: 1px dashed #0d6247;
}

.one-konosament {
  border-left: 1px solid #CCC;
}
.one-konosament:hover {
  border-left: 1px solid #0d6247;
}
.delete-one-konosament {
  position: absolute;
  width: 80px;
  height: 30px;
  top: 40px;
  left: -60px;
  transform: rotate(-90deg);
}

.custom-select {
  height: 34px !important;
  border-radius: 3px !important;
  padding: 1px 8px;
}
.small-description {
  line-height: 11px;
}

</style>